import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  // Button,
  Paper,
  IconButton,
  //   Table,
  //   TableBody,
  TableCell,
  //   TableContainer,
  //   TableHead,
  TableRow,
  tableCellClasses,
  Divider,
} from "@mui/material";
// import { FiDownload } from "react-icons/fi";
// import { Add } from "@mui/icons-material";
import { FontFamily } from "assets";
import { v4 as uuidv4 } from "uuid";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";
import InputField from "components/Input";
import instance from "config/axios";
import routes from "services/System/routes";
// import InputPhone from "components/InputPhone";
// import { emailRegex } from "utils";
import Colors from "assets/Style/Colors";
import { PrimaryButton } from "components/Buttons";
import { SuccessToaster, ErrorToaster } from "components/Toaster";
// import DatePicker from "components/DatePicker";
// import CheckIcon from "@mui/icons-material/Check";
// import EditIcon from "@mui/icons-material/Edit";
import { CleanTypes, getFileSize } from "utils";

import SelectField from "components/Select";
import SupplierServices from "services/Supplier";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
// import UploadFile from "components/UploadFile";

const CustomPaper = styled(Paper)(({ theme }) => ({
  gap: 0,
}));

const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "left",
    whiteSpace: "nowrap",
    backgroundColor: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "left",
    textWrap: "nowrap",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".css-1ru1j9e-MuiTableCell-root ": {
      color: "#ffffff",
      textAlign: "left",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

function CompleteProfile() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    getValues,
    setValue,
  } = useForm();

  const [activeStep, setActiveStep] = useState(0);
  const [loader, setLoader] = useState(false);
  const [licenseDate, setLicenseDate] = useState();
  const [selectedDocumentType, setSelectedDocumentType] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const [banks, setBanks] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  console.log(documentList, "documentList");
  const [documentLink2, setDocumentLink2] = useState("");
  const [progress2, setProgress2] = useState(0);
  const [uploadedSize2, setUploadedSize2] = useState(0);
  const [documentDetail2, setDocumentDetail2] = useState([]);

  const [isDocumentSelected, setIsDocumentSelected] = useState(false);
  const [isDocumentUploaded, setIsDocumentUploaded] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const allowFilesTypeInvoice = [
    // "image/png",
    // "image/jpg",
    // "image/jpeg",
    "application/pdf",
  ];
  const getSupplierDetails = async () => {
    try {
      const data = await SupplierServices.getSupplierDetail({
        supplier_id: id,
      });
      const supplier = data?.data?.supplier;

      if (supplier) {
        // Invoice Details
        setValue("companyName", supplier.inv_trans_type_code || "");
        setValue("authorizePerson", supplier.spec_identification || "");
        setValue("amount", supplier.invoice_line_net_amount || "");
        setValue(
          "invoiceTotalWithoutTax",
          supplier.invoice_total_without_tax || "",
        );
        setValue("amountDue", supplier.amount_due_for_payment || "");

        // Seller Details
        setValue("tradeLicense", supplier.seller_address || "");
        setValue("vatTax", supplier.seller_identifier || "");

        // Buyer Details
        setValue("buyerAddress", supplier.buyer_address || "");
        setValue("buyerIdentifier", supplier.buyer_identifier || "");

        // Tax Breakdown
        setValue("iban", supplier.tax_category_taxable_amount || "");
        setValue("amountAed", supplier.tax_category_tax_amount || "");
        setValue("creditDays", supplier.tax_category_code || "");
        setValue("taxRate", supplier.tax_category_rate || "");

        // Dropdowns
        setSelectedDocumentType({
          id: supplier.business_proc_type,
          name: supplier.business_proc_type,
        });
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getSupplierDetails();
  }, []);


  const handleUploadDocumentInvoices = async (e) => {
    try {
      e.preventDefault();

      setIsDocumentSelected(true);
      setIsDocumentUploaded(false);

      const file = e.target.files[0];
      let arr = [
        {
          id: uuidv4(),
          name: file?.name,
          file: "",
          type: file?.type.split("/")[1],
          size: getFileSize(file.size),
          isUpload: false,
        },
      ];
      if (allowFilesTypeInvoice.includes(file.type)) {
        setDocumentDetail2(arr);
        handleUploadInvoices(file, arr);
      } else {
        ErrorToaster(
          `Only ${CleanTypes(allowFilesTypeInvoice)} formats is supported`,
        );
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleUploadInvoices = async (file, docs) => {
    setProgress2(0);
    try {
      const formData = new FormData();
      formData.append("document", file);
      const { data } = await instance.post(routes.uploadDocuments, formData, {
        onUploadProgress: (progressEvent) => {
          const uploadedBytes = progressEvent.loaded;
          const percentCompleted = Math.round(
            (uploadedBytes * 100) / progressEvent.total,
          );

          setProgress2(percentCompleted);
          setUploadedSize2(getFileSize(uploadedBytes));
        },
      });
      if (data) {
        docs[0].isUpload = true;
        docs[0].file = data?.data?.nations;
        setDocumentDetail2(docs);
        setDocumentLink2(data?.data?.nations);
        SuccessToaster("Document Uploaded");
        setIsDocumentUploaded(true);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleAddDocument = () => {
    if (!documentLink2) {
      ErrorToaster("Please upload a document before adding.");
      return;
    }

    if (!selectedDocumentType?.id)
      return ErrorToaster("Please enter document Type");

    setDocumentList([
      ...documentList,
      {
        id: uuidv4(),
        docType: selectedDocumentType?.name,
        documentLink2,
      },
    ]);
    SuccessToaster("Document Added");
    setSelectedDocumentType([]);
    setDocumentLink2("");
  };

  const handleLicenseDate = (newDate) => {
    try {
      if (newDate == "Invalid Date") {
        setLicenseDate("invalid");
        return;
      }
      setLicenseDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const downloadAllAttachments = async (documentLinks) => {
    if (!documentLinks || documentLinks.trim() === "") {
      ErrorToaster("No attachments available.");
      return;
    }

    const filePath = documentLinks.trim();
    const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
    const fileExtension = filePath.split(".").pop();

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `attachment.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl); // Cleanup
      SuccessToaster("Downloading attachment...");
    } catch (error) {
      console.error("Download failed", error);
      ErrorToaster("Failed to download attachment.");
    }
  };

  // Form submission handlers
  const handleSaveDraft = async () => {
    setLoader(true);
    try {
      const payload = {
        supplier_id: id,
        complete_profile: true,
        is_draft: true,

        inv_trans_type_code: getValues("companyName"),
        business_proc_type: selectedDocumentType?.name || "",
        spec_identification: getValues("authorizePerson"),
        invoice_line_net_amount: getValues("amount"),
        invoice_total_without_tax: getValues("invoiceTotalWithoutTax"),
        amount_due_for_payment: getValues("amountDue"),
        seller_address: getValues("tradeLicense"),
        seller_identifier: getValues("vatTax"),
        legal_registration_identifier_type: selectedDocumentType?.name || "",
        buyer_address: getValues("buyerAddress"),
        buyer_identifier: getValues("buyerIdentifier"),
        tax_category_taxable_amount: getValues("iban"),
        tax_category_tax_amount: getValues("amountAed"),
        tax_category_code: getValues("creditDays"),
        tax_category_rate: getValues("taxRate"),
      };

      const response = await SupplierServices.editSupplier(payload);

      if (response?.responseCode === 200) {
        
        SuccessToaster("Draft saved successfully.");
         navigate("/supplier-listing");
      } else {
        ErrorToaster("Failed to save draft.");
      }
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  const handleSubmitForm = async () => {
    setLoader(true);
    try {
      const payload = {
        supplier_id: id,
        complete_profile: true,
        is_draft: false,

        // Invoice Details
        inv_trans_type_code: getValues("companyName"),
        business_proc_type: selectedDocumentType?.name || "",
        spec_identification: getValues("authorizePerson"),
        invoice_line_net_amount: getValues("amount"),
        invoice_total_without_tax: getValues("invoiceTotalWithoutTax"),
        amount_due_for_payment: getValues("amountDue"),

        // Seller Details
        seller_address: getValues("tradeLicense"),
        seller_identifier: getValues("vatTax"),
        legal_registration_identifier_type: selectedDocumentType?.name || "",

        // Buyer Details
        buyer_address: getValues("buyerAddress"),
        buyer_identifier: getValues("buyerIdentifier"),

        // Tax Breakdown
        tax_category_taxable_amount: getValues("iban"),
        tax_category_tax_amount: getValues("amountAed"),
        tax_category_code: getValues("creditDays"),
        tax_category_rate: getValues("taxRate"),
      };

      console.log(
        "Complete Profile Payload:",
        JSON.stringify(payload, null, 2),
      );

      const response = await SupplierServices.editSupplier(payload);

      if (response?.responseCode === 200) {
        SuccessToaster("Profile updated successfully.");
        navigate("/supplier-listing");
      } else {
        ErrorToaster("Failed to update profile.");
      }
    } catch (error) {
      ErrorToaster(error);
      console.error("Submit error:", error);
    } finally {
      setLoader(false);
    }
  };
  // Function to render the form based on active step
  const renderForm = () => {
    switch (activeStep) {
      case 0:
        return (
          <>
            <Typography
              sx={{
                fontFamily: FontFamily.Halvetica,
                fontSize: "22px",
                fontWeight: 700,
                fontStyle: "Bold",
                mb: 1.5,
              }}
            >
              Invoice Details
            </Typography>

            <Grid container spacing={1}>
              {/* Company Info Form */}
              <Grid item xs={12} sm={6}>
                <InputField
                  disabled={false}
                  size={"small"}
                  label={"Invoice Transaction Type Code"}
                  placeholder={"Enter Code"}
                  register={register("companyName", {
                    required: "Company is required.",
                  })}
                  error={errors?.companyName?.message}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <SelectField
                  label="Business Process Type"
                  options={[
                    {
                      id: 1,
                      name: "Trade License",
                    },
                    {
                      id: 2,
                      name: "TAX Certificate",
                    },
                  ]}
                  selected={selectedDocumentType}
                  onSelect={(value) => {
                    setSelectedDocumentType(value);
                  }}
                  register={register("periodicInvoice", {
                    // required: "Please select invoice.",
                  })}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputField
                  disabled={false}
                  size={"small"}
                  label={"Specification Identifier"}
                  placeholder={"Enter Identifier"}
                  register={register("authorizePerson", {
                    required: "Authorize person name is required.",
                  })}
                  error={errors?.authorizePerson?.message}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputField
                  label={"Invoice line Net Amount"}
                  placeholder={"Enter Amount"}
                  error={errors?.amount?.message}
                  register={register("amount", {
                    required: "Authorize person name is required.",
                  })}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputField
                  label={"Invoice Total without Tax"}
                  placeholder={"Enter Amount"}
                  register={register("invoiceTotalWithoutTax")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputField
                  label={"Amount due for Payment"}
                  placeholder={"Enter Amount"}
                  register={register("amountDue")}
                />
              </Grid>
            </Grid>
          </>
        );
      case 1:
        return (
          <>
            <Typography
              sx={{
                fontFamily: FontFamily.Halvetica,
                fontSize: "22px",
                fontWeight: 700,
                fontStyle: "Bold",
                mb: 1.5,
              }}
            >
              Seller Details
            </Typography>
            <Grid container spacing={1}>
              {/* Company Info Form */}
              <Grid item xs={12} sm={6}>
                <InputField
                  disabled={false}
                  size={"small"}
                  label={"Electronic address"}
                  placeholder={"Enter Address"}
                  register={register("tradeLicense", {
                    required: "Trade License no is required.",
                  })}
                  error={errors?.tradeLicense?.message}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputField
                  disabled={false}
                  size={"small"}
                  label={"Electronic Identifier"}
                  placeholder={"Enter Identifier"}
                  register={register("vatTax", {
                    required: "VAT/TAX no is required.",
                  })}
                  error={errors?.vatTax?.message}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <SelectField
                  label="Legal registration identifier type"
                  options={[
                    {
                      id: 1,
                      name: "Trade License",
                    },
                    {
                      id: 2,
                      name: "TAX Certificate",
                    },
                  ]}
                  selected={selectedDocumentType}
                  onSelect={(value) => {
                    setSelectedDocumentType(value);
                  }}
                  register={register("periodicInvoice", {
                    // required: "Please select invoice.",
                  })}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Divider sx={{ my: 3, ml: 1.5, mr: 1.5 }} />
              </Grid>

              <Grid item xs={12} sm={12}>
                <Typography
                  sx={{
                    fontFamily: FontFamily.Halvetica,
                    fontSize: "22px",
                    fontWeight: 700,
                    fontStyle: "Bold",
                    mb: 1.5,
                  }}
                >
                  Buyer Details
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputField
                  disabled={false}
                  size={"small"}
                  label={"Electronic address"}
                  placeholder={"Enter Address"}
                  register={register("buyerAddress", {})}
                  error={errors?.tradeLicense?.message}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputField
                  disabled={false}
                  size={"small"}
                  label={"Electronic Identifier"}
                  placeholder={"Enter Identifier"}
                  register={register("buyerIdentifier", {})}
                  error={errors?.vatTax?.message}
                />
              </Grid>
            </Grid>
          </>
        );
      case 2:
        return (
          <>
            <Typography
              sx={{
                fontFamily: FontFamily.Halvetica,
                fontSize: "22px",
                fontWeight: 700,
                fontStyle: "Bold",
                mb: 1.5,
              }}
            >
              Tax Breakdown
            </Typography>
            <Grid container spacing={1}>
              {/* Company Info Form */}
              <Grid item xs={12} sm={6}>
                <InputField
                  disabled={false}
                  size={"small"}
                  label={"Tax category Taxable Amount"}
                  placeholder={"Enter IBAN"}
                  register={register("iban", {
                    required: "IBAN is required.",
                  })}
                  error={errors?.iban?.message}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputField
                  disabled={false}
                  size={"small"}
                  label={"Tax category Tax Amount"}
                  placeholder={"Enter Tax category Tax Amount"}
                  register={register("amountAed", {
                    required: "Amount Aed is required.",
                  })}
                  error={errors?.amountAed?.message}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputField
                  disabled={false}
                  size={"small"}
                  label={"Tax category code"}
                  placeholder={"Enter Tax category code"}
                  register={register("creditDays", {
                    required: "Credit Days is required.",
                  })}
                  error={errors?.creditDays?.message}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputField
                  disabled={false}
                  size={"small"}
                  label={"Tax category rate"}
                  placeholder={"Enter Tax category rate"}
                  register={register("taxRate", {
                    required: "Credit Days is required.",
                  })}
                  error={errors?.creditDays?.message}
                />
              </Grid>
            </Grid>
          </>
        );
      default:
        return <Typography>Select a form to fill</Typography>;
    }
  };

  return (
    <Box sx={{ m: 4, mb: 8 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
          mt: 4,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: "#094526",
            fontFamily: FontFamily.Halvetica,
            fontSize: "32px",
            fontWeight: 700,
            fontStyle: "Bold",
          }}
        >
          Complete Profile
        </Typography>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} md={3.5}>
          <CustomPaper
            sx={{
              borderRadius: "6px",
              border: `1px solid ${Colors.grey}`,
              display: "flex",
              flexDirection: "column",
              gap: 2,
              // width: "380px",
              padding: "0px !important",
              margin: "0px !important",
              // borderLeft: `6px solid #5BBC0F`,
            }}
          >
            <Box
              sx={{
                padding: "0px !important",
                borderLeft:
                  activeStep === 0 ? "6px solid #5BBC0F" : "transparent",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  marginTop: "15px",
                  marginBottom: "15px",

                  // borderLeft:  activeStep === 0 ? "6px solid #5BBC0F" : "transparent",
                }}
              >
                <IconButton
                  sx={{
                    backgroundColor:
                      activeStep === 0 ? "transparent" : "transparent",
                    color: activeStep === 0 ? "#5BBC0F" : Colors.grey,
                    border: "1px solid",
                    borderColor: activeStep === 0 ? "#5BBC0F" : Colors.grey,
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    padding: 1,
                    marginLeft: "20px",
                  }}
                  onClick={() => setActiveStep(0)}
                >
                  <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
                    01
                  </Typography>
                </IconButton>
                <Typography
                  sx={{
                    color: activeStep === 0 ? "#5BBC0F" : Colors.grey,
                    fontWeight: 700,
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  onClick={() => setActiveStep(0)}
                >
                  Invoice Details
                </Typography>
              </Box>
            </Box>

            <Divider sx={{ borderColor: Colors.grey }} />

            <Box
              sx={{
                borderLeft:
                  activeStep === 1 ? "6px solid #5BBC0F" : "transparent",
                padding: "0px !important",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  //  borderLeft:  activeStep === 1 ? "6px solid #5BBC0F" : "transparent",
                  marginBottom: "15px",
                  marginTop: "15px",
                }}
              >
                <IconButton
                  sx={{
                    backgroundColor:
                      activeStep === 1 ? "transparent" : "transparent",
                    color: activeStep === 1 ? "#5BBC0F" : Colors.grey,
                    border: "1px solid",
                    borderColor: activeStep === 1 ? "#5BBC0F" : Colors.grey,
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    padding: 1,
                    marginLeft: "20px",
                  }}
                  onClick={() => setActiveStep(1)}
                >
                  <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
                    02
                  </Typography>
                </IconButton>
                <Typography
                  sx={{
                    color: activeStep === 1 ? "#5BBC0F" : Colors.grey,
                    fontWeight: 700,
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  onClick={() => setActiveStep(1)}
                >
                  Seller & Buyer Details
                </Typography>
              </Box>
            </Box>

            <Divider
              sx={{ borderColor: Colors.grey, margin: "0px !important" }}
            />

            <Box
              sx={{
                borderLeft:
                  activeStep === 2 ? "6px solid #5BBC0F" : "transparent",
                padding: "0px !important",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  marginBottom: "15px",
                  marginTop: "15px",

                  // borderLeft:  activeStep === 2 ? "6px solid #5BBC0F" : "transparent",
                }}
              >
                <IconButton
                  sx={{
                    backgroundColor:
                      activeStep === 2 ? "transparent" : "transparent",
                    color: activeStep === 2 ? "#5BBC0F" : Colors.grey,
                    border: "1px solid",
                    borderColor: activeStep === 2 ? "#5BBC0F" : Colors.grey,
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    padding: 1,
                    marginLeft: "20px",
                  }}
                  onClick={() => setActiveStep(2)}
                >
                  <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
                    03
                  </Typography>
                </IconButton>
                <Typography
                  sx={{
                    color: activeStep === 2 ? "#5BBC0F" : Colors.grey,
                    fontWeight: 700,
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  onClick={() => setActiveStep(2)}
                >
                  Tax Breakdown
                </Typography>
              </Box>
            </Box>
          </CustomPaper>
        </Grid>

        <Grid item xs={12} md={8}>
          {renderForm()}
        </Grid>
      </Grid>
      {activeStep === 0 && (
        <>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}
          >
            <PrimaryButton
              onClick={() => {
                if (activeStep < 2) {
                  setActiveStep(activeStep + 1);
                }
              }}
              title={"Next"}
            />
          </Box>
        </>
      )}

      {activeStep === 1 && (
        <>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}
          >
            <PrimaryButton
              onClick={() => {
                if (activeStep > 0) {
                  setActiveStep(activeStep - 1);
                }
              }}
              title={"Back"}
            />

            <PrimaryButton
              onClick={() => {
                if (activeStep < 2) {
                  setActiveStep(activeStep + 1);
                }
              }}
              title={"Next"}
            />
          </Box>
        </>
      )}

      {activeStep === 2 && (
        <>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}
          >
            <PrimaryButton
              onClick={handleSaveDraft}
              title={"Save as Draft"}
              bgcolor={Colors.grey}
            />
            <PrimaryButton
              onClick={handleSubmitForm}
              title={"Update"}
              loading={loader}
            />
          </Box>
        </>
      )}
    </Box>
  );
}

export default CompleteProfile;
